// app/core/organization/organization-utils.ts

/**
 * Interface for organization data
 */
export interface OrganizationData {
    name: string;
    logo?: string;
}

/**
 * Store organization data in localStorage
 */
export function storeOrganizationData(orgData: OrganizationData): void {
    // Store the complete object    
    // Also store individual properties for easy access
    localStorage.setItem('orgName', orgData.name || '');
    localStorage.setItem('orgLogo', orgData.logo || '');
}

/**
 * Get organization data from localStorage
 */
export function getOrganizationData(): OrganizationData {
    try {
        // Try to get as complete object first
        const orgStr = localStorage.getItem('organization');
        if (orgStr) {
            return JSON.parse(orgStr);
        }
    } catch (e) {
        console.error('Error parsing organization data', e);
    }
    
    // Fall back to individual properties
    let features = [];
    try {
        const featuresStr = localStorage.getItem('orgFeatures');
        if (featuresStr) {
            features = JSON.parse(featuresStr);
        }
    } catch (e) {
        console.error('Error parsing features', e);
    }
    
    return {
        name: localStorage.getItem('orgName') || '',
        logo: localStorage.getItem('orgLogo') || ''
    };
}